import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

import TextDate from "components/text/TextDate";
import TextBoolean from "components/text/TextBoolean";
import TextAmount from 'components/text/TextAmount';
import TextPercent from 'components/text/TextPercent';
import TextNumber from 'components/text/TextNumber';
import TransactionKey from 'calculator/components/TransactionKey';
import TextCalculatedFor from 'calculator/components/TextCalculatedFor';


const CostResultList = ({ data }) => {

    console.log("Cost result", data);

    const [showPayments, setShowPayments] = useState(false); 

    if (!data){
      return (
        <div/>
      );
    }
    let costs = data;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="11" className="text-left">
              <span className="calc-setting-table-header">Kostnaður sem var notaður í útreikningum&nbsp;&nbsp;&nbsp;&nbsp;</span>
              {/* <input id="checkCostid1" type="checkbox" checked={this.state.showPayments} onChange={this.showshowPaymentsClick}/><label className="calc-small-checkbox-label" htmlFor="checkCostid1" >Sýna greiðslur</label> */}
            </th>
          </tr>
          <tr>
            <th className="text-left">Reiknað f.</th>
            <th className="text-left">Færsl.nr.</th>
            <th className="text-left">Færslulykill</th>
            <th className="text-right">Dagsetning</th>
            <th className="text-right">Upphæð</th>
            <th className="text-right">VSK</th>
            <th className="text-right">VSK %</th>

            <th className="text-right">Drv</th>
            <th className="text-right">Hst.Drv</th>
            <th className="text-right">FTS</th>

            <th className="text-right">Gen</th>

          </tr>
          </thead>
          <tbody>
          {costs.map((item,i) => {
            let paymentContent = showPayments ? (
              <tr key={i}>
                <td colSpan="4" className="text-right"><b>Greitt:</b></td>
                <td className="text-right"><TextAmount value={item.paymentAmount}/></td>
                <td className="text-right"><TextAmount value={item.vatPaidAmount}/></td>
                <td>&nbsp;</td>
                <td className="text-right"><TextAmount value={item.penaltyInterestPaidAmount}/></td>
                <td className="text-right"><TextAmount value={item.capitalizedPenaltyInterestPaidAmount}/></td>
                <td className="text-right"><TextAmount value={item.capitalGainsTaxPaidAmount}/></td>
                <td>&nbsp;</td>
              </tr>
            ) : null;

            // console.log("WTF", item.transactionKey);

            return([
              <tr key={i + "inner"}>
                <td className="text-left"><TextCalculatedFor data={item.calculatedFor}/></td>
                <td className="text-left"><TextNumber value={item.transactionNumber}/></td>
                <td className="text-left"><TransactionKey data={item.transactionKey}/></td>
                <td className="text-right"><TextDate value={item.dueDate}/></td>
                <td className="text-right"><TextAmount value={item.amount}/></td>
                <td className="text-right"><TextAmount value={item.vatAmount}/></td>
                <td className="text-right"><TextAmount value={item.vatRate}/></td>
                <td className="text-right"><TextAmount value={item.penaltyInterestAmount}/></td>
                <td className="text-right"><TextAmount value={item.capitalizedPenaltyInterestAmount}/></td>
                <td className="text-right"><TextAmount value={item.capitalGainsTaxAmount}/></td>
                <td className="text-right"><TextBoolean value={item.generated}/></td>
              </tr>,
                paymentContent]
            )
          })}

          </tbody>
        </table>
      </div>
    );  
}

CostResultList.propTypes = {
  data: PropTypes.array,
};



export default CostResultList;
